import { trackException } from "./monitoring/appInsights";
import { recoverTokenInfo } from "./recoverTokenInfo";
import { getErrorMessage } from "./getErrorMessage";
import { toLogProperties } from "./logProperties";
import { AxiosError } from "axios";

export type ReportedError = Error | AxiosError | string | unknown;

export type ErrorReportOptions = {
  eventName: string;
  properties?: Record<string, unknown>;
  showToast?: boolean;
  errorMessage?: string;
  errorCode?: string;
};

const toErrorInstance = (error: ReportedError, fallbackMessage: string) => {
  if (error instanceof Error) {
    return error;
  }

  return new Error(fallbackMessage);
};

export const reportError = async (error: ReportedError, options: ErrorReportOptions) => {
  const errorMessage = getErrorMessage(error);
  const exception = toErrorInstance(error, errorMessage);
  const isAxiosError = error instanceof AxiosError;

  const properties = toLogProperties({
    eventName: options.eventName,
    message: errorMessage,
    user: recoverTokenInfo("ibabs-user-id"),
    url: typeof window !== "undefined" ? window.location.href : undefined,
    path: typeof window !== "undefined" ? window.location.pathname : undefined,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
    language: typeof navigator !== "undefined" ? navigator.language : undefined,
    mode: import.meta.env.MODE,
    errorName: exception.name,
    stack: exception.stack,
    ...(isAxiosError && {
      statusCode: error.response?.status,
      endpoint: error.config?.url,
      method: error.config?.method,
    }),

    ...options.properties,
  });

  trackException(exception, properties);
};
